
import { SiriusAppModule } from 'sirius-framework';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TextMaskModule } from "angular2-text-mask";
import { DocumentPopupModule } from '../../popup/documentPopup/documentPopup.module';
import { IdleTimeOutModule } from '../../popup/idleTimeOut/idletimeout.module';
import { KvkkPopupModule } from "../../popup/kvkkPopup/kvkkPopup.module";
import { CookieInfoModule } from "../../popup/cookieinfo/cookieinfo.module";

import { ApplicationCardComponent } from '../components/application-card/application-card.component';
import { RedirectComponent } from '../components/redirect/redirect.component';
import { TreeMenuComponent } from '../components/tree-menu/tree-menu.component';
import { PopupComponent } from '../../popup/informationPopup/popup.component';
import { ProcessDetailComponent } from '../components/process-detail/process-detail.component';
import { ProcessActionComponent } from '../components/process-action/process-action.component';
import { CancelProcessComponent } from '../../popup/cancel-process/cancel-process.component';
import { MessageShowComponent } from '../../popup/message-show/message-show.component';
import { DocumentPopupComponent } from '../../popup/documentPopup/documentPopup.component'
import { DocumentPopupComponent2 } from '../../popup/documentPopup2/documentPopup2.component'
import { OwnAccountsComponent } from '../../popup/own-accounts/own-accounts.component'; 
import { UiDocumentViewerComponent } from '../components/ui-documentviewer/ui-documentviewer.component';

import { ValidationService } from '../service/validation-service';
import { PopupService } from '../../popup/informationPopup/popup.service'; 
import { TimeoutPopupService } from "../../popup/idleTimeOut/idletimeout.service";
import { LoadingComponent } from '../../global/loading/loading.component';
import { SwitchComponent } from '../components/switch/switch.component';

import { ShadowHeaderDirective } from "../directives/shadow-header.directive";
import { HeightHeaderImageDirective } from "../directives/height-header-image.directive";
import { OnlyNumber } from "./../directives/only-number.directive";
import { OnlyAlphabetic } from "./../directives/only-alphabetic.directive";
import { OnlyAlphaNumeric } from "./../directives/only-alphaNumeric.directive";
import { OnlyAlphaNumSafeChar } from "./../directives/only-alphaNumSafeChar.directive";
import { MinMaxAmount } from "./../directives/minMaxAmount.directive";
import { ShortenPipe } from './../pipes/shorten.pipe';
import { IbanPipe } from './../pipes/iban.pipe';
import { SiriusAngularCaptchaModule } from "@ibtech/sirius-angular-captcha";
import { SiriusAngularTextboxModule } from "@ibtech/sirius-angular-textbox";
import { SiriusAngularLabelModule } from "@ibtech/sirius-angular-label";
import { SiriusAngularContainerModule } from "@ibtech/sirius-angular-container";
import { SiriusAngularIbanModule } from "@ibtech/sirius-angular-iban";
import { SiriusAngularNumericTextboxModule } from "@ibtech/sirius-angular-numerictextbox";
import { ModalModule } from 'ngx-bootstrap/modal';
import { FaqModule } from '../../faq/faq.module';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TextMaskModule,
    KvkkPopupModule,
    CookieInfoModule,
    IdleTimeOutModule,
    DocumentPopupModule,
    SiriusAngularCaptchaModule,
    SiriusAngularTextboxModule,
    SiriusAngularLabelModule,
    SiriusAngularContainerModule,
    SiriusAngularIbanModule,
    SiriusAngularNumericTextboxModule,
    FaqModule,
    ModalModule.forRoot(),
  ],
  declarations: [
    ApplicationCardComponent,
    RedirectComponent,
    TreeMenuComponent,
    PopupComponent,
    ProcessDetailComponent,
    ProcessActionComponent,
    CancelProcessComponent,
    MessageShowComponent,
    OwnAccountsComponent,
    LoadingComponent,
    SwitchComponent,
    ShadowHeaderDirective,
    HeightHeaderImageDirective,
    OnlyNumber,
    OnlyAlphabetic,
    OnlyAlphaNumeric,
    ShortenPipe,
    IbanPipe,
    OnlyAlphaNumSafeChar,
    MinMaxAmount,
    UiDocumentViewerComponent,
    DocumentPopupComponent2
  ],
  exports: [
    ApplicationCardComponent,
    RedirectComponent,
    TreeMenuComponent,
    FormsModule,
    ReactiveFormsModule,
    TextMaskModule,
    IdleTimeOutModule,
    PopupComponent,
    ProcessDetailComponent,
    ProcessActionComponent,
    CancelProcessComponent,
    MessageShowComponent,
    OwnAccountsComponent,
    LoadingComponent,
    SwitchComponent,
    ShadowHeaderDirective,
    HeightHeaderImageDirective,
    OnlyNumber,
    OnlyAlphabetic,
    OnlyAlphaNumeric,
    ShortenPipe,
    IbanPipe,
    OnlyAlphaNumSafeChar,
    DocumentPopupModule,
    MinMaxAmount,
    UiDocumentViewerComponent,
    DocumentPopupComponent2,
    SiriusAngularCaptchaModule,
    SiriusAngularTextboxModule,
    SiriusAngularLabelModule,
    SiriusAngularContainerModule,
    SiriusAngularIbanModule,
    SiriusAngularNumericTextboxModule,
    KvkkPopupModule,
    CookieInfoModule,
    FaqModule
  ],
  providers: [
    PopupService,
    ValidationService,
    TimeoutPopupService
  ]
})
export class SharedModule extends SiriusAppModule { }
